var render = function render(_c,_vm){return _c('div',{staticClass:"media-block container"},[_c('sanity-media',{staticClass:"text-center",attrs:{"image":_vm.props.image,"video":_vm.props.video}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }